export const RELOAD = 'gift_card_product/RELOAD';

export function reload() {
  return { type: RELOAD, payload: { data: window.giftCardProduct }};
}
